import styled from "@emotion/styled"
import { breakpoint, spacingStaticMd, spacingStaticSm } from "@porsche-design-system/components-react/emotion"
import { Skeleton } from "src/components/skeleton"

export const VehicleHistoryHeaderSkeleton = (props: { className?: string }) => {
	return (
		<Header {...props}>
			<StyledSkeletonPicture />

			<HeadingTagsWrapper>
				<Skeleton.Heading size="xl" $width="35%" />

				<TagsContainer>
					<Skeleton.Tag $width="80px" />
					<Skeleton.Tag $width="80px" />
					<Skeleton.Tag $width="150px" />
					<Skeleton.Tag $width="60px" />
					<Skeleton.Tag $width="60px" />
					<Skeleton.Tag $width="120px" />
				</TagsContainer>
			</HeadingTagsWrapper>
		</Header>
	)
}

const Header = styled.header`
    display: flex;
    flex-direction: column;
    gap: ${spacingStaticSm};

    @media (min-width: ${breakpoint.m}px) {
        flex-direction: row;
        align-items: center;
        gap: ${spacingStaticMd};
    }
`

const HeadingTagsWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${spacingStaticSm};
`

const StyledSkeletonPicture = styled(Skeleton.Picture)`
    @media (min-width: ${breakpoint.m}px) {
        min-width: 160px;
        width: 160px;
    }
`

const TagsContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: ${spacingStaticSm};
`
